// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"149":"component---src-templates-index-page-tsx","218":"component---src-pages-404-tsx"}[chunkId] + "-" + {"149":"629d048178ec0d7a646f","218":"372d652186c6386fe989"}[chunkId] + ".js";
};